import React from 'react';
import TextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import ReactRating from 'react-rating';
import Button from './Button';
import YellowGreenButton from './YellowGreenButton';
import i18n from '../utils/i18n';
import StarEmpty from '../images/star-empty.png';
import StarFull from '../images/star-full.png';
import './styles/AppRateComponent.scss';

const AppRateComponent = ({
  ratingEnd,
  sentRatingId,
  onStarClick,
  sendRating,
  rating,
  askForAdditionalFeedback,
  feedback,
  handleFeedbackChange,
  sendFeedback,
  onClose,
  onFinish
}) => (
  <div className="app-rate-component">
    {!ratingEnd && (
      <div>
        <div className="app-rate-info">
          {i18n.t('modals.appRate.HOW_LIKELY_DEUCE')}
        </div>
        <ReactRating
          emptySymbol={
            <img className="star" src={ StarEmpty } alt="empty-star" />
          }
          fullSymbol={ <img className="star" src={ StarFull } alt="empty-star" /> }
          stop={ 10 }
          start={ 0 }
          initialRating={ rating }
          onChange={ onStarClick }
          readonly={ sentRatingId !== null }
        />
        {askForAdditionalFeedback && (
          <div className="additional-feedback">
            <div className="additional-feedback-header">
              {i18n.t('modals.appRate.ANY_OTHER_FEEDBACK')}
            </div>
            <div className="additional-feedback-input">
              <TextField
                multiLine={ true }
                rowsMax={ 8 }
                rows={ 6 }
                fullWidth={ true }
                name="feedback"
                value={ feedback }
                onChange={ handleFeedbackChange }
                underlineShow={ false }
                textareaStyle={ {
                  borderRadius: '4px',
                  boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.11)',
                  border: '1px solid #F3F3F3',
                  padding: '10px'
                } }
                hintText={ i18n.t('modals.appRate.WRITE_HERE') }
                hintStyle={ {
                  padding: '10px',
                  top: '10px',
                  fontSize: '19px',
                  color: '#6e6e6e'
                } }
              />
            </div>
          </div>
        )}
      </div>
    )}
    {ratingEnd && (
      <div>
        <div className="app-rate-info">
          {i18n.t('feedbackScreens.THANKS_FOR_FEEDBACK')}
        </div>
      </div>
    )}

    <div className="app-rate-buttons">
      <div className="app-rate-close-button">
        <Button
          buttonClass="modal-close-button-style"
          text={
            ratingEnd
              ? i18n.t('modals.appRate.CLOSE')
              : i18n.t('modals.appRate.CANCEL')
          }
          onClick={ askForAdditionalFeedback || ratingEnd ? onFinish : onClose }
        />
      </div>
      {!ratingEnd &&
        (rating || askForAdditionalFeedback) && (
        <div className="send-button-wrapper">
          <YellowGreenButton
            text={
              askForAdditionalFeedback
                ? i18n.t('modals.appRate.FINISH')
                : i18n.t('modals.appRate.SEND_RATING')
            }
            onClick={ askForAdditionalFeedback ? sendFeedback : sendRating }
          />
        </div>
      )}
    </div>
  </div>
);

AppRateComponent.propTypes = {
  ratingEnd: PropTypes.bool,
  sentRatingId: PropTypes.number,
  onStarClick: PropTypes.func,
  sendRating: PropTypes.func,
  rating: PropTypes.number,
  askForAdditionalFeedback: PropTypes.bool,
  feedback: PropTypes.string,
  handleFeedbackChange: PropTypes.func,
  sendFeedback: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired
};

AppRateComponent.defaultProps = {
  ratingEnd: false,
  sentRatingId: null,
  onStarClick: () => {},
  sendRating: () => {},
  rating: null,
  askForAdditionalFeedback: false,
  feedback: '',
  handleFeedbackChange: () => {},
  sendFeedback: () => {}
};

export default AppRateComponent;



// WEBPACK FOOTER //
// ./src/components/AppRateComponent.js